import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthActions } from '@auth/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { PortalStatusActions } from '@features/referentiel/actions/portal-status.actions';
import { PortalStatusService } from '@features/referentiel/services/portal-status.service';

@Injectable()
export class PortalStatusEffects {
  initActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.userProfileLoaded),
      map(() => PortalStatusActions.getPortalStatuses()),
    ),
  );

  loadActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PortalStatusActions.getPortalStatuses),
      switchMap(() =>
        this.portalStatusService.getPortalStatuses().pipe(
          map((portalStatuses) => PortalStatusActions.getPortalStatusesSuccess({ portalStatuses })),
          catchError((error) =>
            of(PortalStatusActions.getPortalStatusesFailure({ errorMessage: error })),
          ),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private portalStatusService: PortalStatusService) {}
}
